import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateAbandonedCartPreferenceApiCall, getAbandonedCartPreferenceApiCall } from "./abandoned-cart-preference.apis";
import { AbandonedCartPreferenceActions, AbandonedCartPreferenceParams, AbandonedCartPreferenceStatus } from "./abandoned-cart-preference.interface";
import { StoreState } from "../../store/store.interface";
import { ActionStatus } from "../../common/constants/action-status";

export const abandonedCartPreference = createAsyncThunk('abandonedCartPreference', async ({ token, action }: AbandonedCartPreferenceParams, thunkAPI) => {
  try {
    if ([ AbandonedCartPreferenceActions.subscribe, AbandonedCartPreferenceActions.unsubscribe ].includes(action)) {
      return mapApiCall(await updateAbandonedCartPreferenceApiCall(token, action));
    }

    return mapApiCall(await getAbandonedCartPreferenceApiCall(token));
  } catch (error: any) {
    if (error.responseStatus === 400) {
      // Magento returns a 400 when magento cannot find the token.
      // In this case, we consider them to have already unsubsubscribed
      // since they may have clicked an old link and we do not want to
      // given them an error message directing them to customer service.
      return {
        status: AbandonedCartPreferenceStatus.alreadyUnsubscribed
      };
    } else {
      return thunkAPI.rejectWithValue({
        status: 'error'
      });
    }
  }
}, {
  condition: ((_arg, { getState }) => {
    const state = getState() as StoreState;
    return state.abandonedCartPreferenceState.status !== ActionStatus.loading
  })
});

function mapApiCall(apiResponse: any) {
  return {
    status: apiResponse?.preference ? AbandonedCartPreferenceStatus.subscribed : AbandonedCartPreferenceStatus.unsubscribed
  };
}
